import styled, { css } from 'styled-components';
import Badge from '@material-ui/core/Badge';
import { Props } from './RoBadge.types';

import colors from '../Colors/colors';

export const Container = styled(Badge)<Props>`
  > span{
    top: -2px;
    right: 16px;
    width: auto;
    height: auto;
    padding: 0px 6px;
    font-size: 11px;
    border-radius: 9px;
    line-height: 16px;
    background: ${props => colors[props.bg[0]][props.bg[2]]};
    transform: translate(100%, 0);
    color: #fff;
    font-family: monospace;
    font-weight: bold;
    box-shadow: 0 0 5px 1px rgba(0,0,0,0.6);
    white-space: nowrap;
    ${props =>
      props.asActive &&
      css`
        min-width: 9px;
        min-height: 9px;
        padding: 0;
        border-radius: 50%;
        top: 2px;
        right: 11px;
        &:after {
          width: 13px;
          height: 13px;
          content: '';
          top: -2px;
          left: -2px;
          display: block;
          background: none;
          position: absolute;
          border-radius: 50%;
          box-shadow: 0 0 0 2px ${colors[props.bg[0]][props.bg[2]]};
        }
      `}
    ${props =>
      props.invert &&
      css`
        background: #fff;
        color: ${colors[props.bg[0]][props.bg[2]]};
        &:after {
          box-shadow: 0 0 0 2px #fff;
        }
      `}
    ${props =>
      props.direction === 'left' &&
      css`
        transform: translate(-100%, 0);
        top: -2px;
        left: 16px;
        right: auto;
        ${props.asActive &&
          css`
            top: 2px;
            left: 11px;
            right: auto;
          `};
      `}
  }
`;
